import { Row } from '../common/forms/layout.js';
import { Column3 } from '../common/forms/layout.js';
import { Column4 } from '../common/forms/layout.js';
import { Column6 } from '../common/forms/layout.js';
import { Column8 } from '../common/forms/layout.js';
import { Column9 } from '../common/forms/layout.js';
import { Column12 } from '../common/forms/layout.js';
import ListView from '../common/configuration/View/ListView.js';

const fields = {
    naziv: {
        key: 'naziv',
        type: 'input',
        templateOptions: {
            label: 'Naziv',
            required: true,
            focus: true
        }
    },
    oib: {
        key: 'oib',
        type: 'input',
        templateOptions: {
            label: 'OIB'
        }
    },
    radno_vrijeme: {
        key: 'radno_vrijeme',
        type: 'input',
        templateOptions: {
            label: 'Radno vrijeme'
        }
    },
    napomena: {
        key: 'napomena',
        type: 'textarea',
        templateOptions: {
            label: 'Napomena'
        }
    },
    adresa: {
        key: 'adresa',
        type: 'input',
        templateOptions: {
            label: 'Adresa'
        }
    },
    postanski_broj: {
        key: 'postanski_broj',
        type: 'input',
        templateOptions: {
            label: 'Poštanski broj'
        }
    },
    mjesto: {
        key: 'mjesto',
        type: 'input',
        templateOptions: {
            label: 'Mjesto'
        }
    },
    telefon: {
        key: 'telefon',
        type: 'input',
        templateOptions: {
            label: 'Telefon'
        }
    },
    email: {
        key: 'email',
        type: 'input',
        templateOptions: {
            label: 'E-mail'
        }
    }
};

export default function(ac, app) {
    var ordinacija = app.getEntity('Ordinacija');
    var nalozi = app.getEntity('RadniNalog');
    var view = new ListView();
    view.setEntity(nalozi);
    view.fields([
        ac
            .field('datum_naloga', 'date')
            .label('Datum naloga')
            .cssClasses(['col-lg-3']),
        ac
            .field('pacijent', 'template')
            .cssClasses(['col-lg-4'])
            .template(function(entry) {
                return `${
                    entry.pacijent
                }<br\><small><i class="fa fa-clock-o"></i> Status: <strong>${entry.status}</strong></small>`;
            }),
        ac
            .field('broj_naloga', 'template')
            .label('Broj naloga')
            .cssClasses(['col-lg-2', 'text-right'])
            .template(function(entry) {
                return '<a ui-sref="radniNalog.details({id: entry.id})" class="btn btn-xs btn-success " type="button"><i class="fa fa-search"></i> {{entry.sifra_naloga}}</a>';
            })
    ]);

    nalozi.views['OrdinacijaViews'] = view;

    // poreznaStopa.listView()
    //     .title('Porezne stope')
    //     .icon('<i class="fa fa-bar-chart fa-3x"></i>')
    //     .fields([
    //         ac.field('naziv')
    //             .label('Naziv stope')
    //             .cssClasses(['col-md-3']),
    //         ac.field('stopa')
    //             .cssClasses(['col-md-2']),
    //         ac.field('vazi_od', 'date')
    //             .label('Važi od')
    //             .cssClasses(['col-md-3']),
    //         ac.field('vazi_do', 'date')
    //             .label('Važi do')
    //             .cssClasses(['col-md-3']),
    //     ])
    //     .listActions([
    //         'edit',
    //         'delete'
    //     ]);

    ordinacija
        .creationView()
        .title('Ordinacije')
        .fields([
            [
                Row([Column9([fields.naziv])]),
                Row([Column3([fields.oib]), Column9([fields.radno_vrijeme])]),
                Row([Column12([fields.napomena])])
            ],

            [
                Row([Column6([fields.adresa]), Column3([fields.postanski_broj]), Column3([fields.mjesto])]),
                Row([Column4([fields.telefon]), Column8([fields.email])]),
                { template: '<hr/>' }
            ]
        ]);

    return ordinacija;
}



// WEBPACK FOOTER //
// ./app/components/ordinacija/config.js